import {Component, ViewContainerRef, OnInit, AfterViewInit, Inject, Renderer2, ElementRef} from '@angular/core';
import {
    AuthService,
    GoogleAnalyticsService,
    LanguageService,
    FeaturesService,
    EventBusService,
    SeoService_Generic,
    FacebookAnalyticsService,
    ShareDataService
} from '@signature-it/ngx-generic/services';
import { AppComponent as AppComponent_Generic } from '@signature-it/ngx-generic/components/app';
import {Router} from '@angular/router';
import {Store} from '@ngrx/store';
import {DOCUMENT} from '@angular/common';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    standalone: false
})
export class AppComponent extends AppComponent_Generic implements OnInit, AfterViewInit {
    constructor(protected router: Router,
                protected auth: AuthService,
                protected analyticsSvc: GoogleAnalyticsService,
                protected langSvc: LanguageService,
                protected featureSvc: FeaturesService,
                protected store$: Store<any>,
                viewRef: ViewContainerRef,
                protected renderer2: Renderer2,
                @Inject(DOCUMENT) doc,
                protected eventBusService: EventBusService,
                protected seoSvc: SeoService_Generic,
                protected facebookSvc: FacebookAnalyticsService,
                private shareService: ShareDataService,
                private host: ElementRef) {
       super(router, auth, analyticsSvc, langSvc, featureSvc, viewRef, renderer2, doc, eventBusService, seoSvc, facebookSvc);
    }

    ngOnInit(): void {
        super.ngOnInit();
        const hostEl = this.host.nativeElement;
        if(this.shareService.isMobileMode()){
            this.renderer2.addClass(hostEl, 'mobile-mode');
            this.renderer2.removeClass(hostEl, 'desktop-mode');
        } else {
            this.renderer2.addClass(hostEl, 'desktop-mode');
            this.renderer2.removeClass(hostEl, 'mobile-mode');
        }
    }

    ngAfterViewInit(): void {
        super.ngAfterViewInit();
    }
}
